import { Route, Routes } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ScrollToTop from "./components/ScrollToTop";
import InitiativesPage from "./pages/InitiativesPage";
import DonatePage from "./pages/DonatePage";
import ContactPage from "./pages/ContactPage";
import TeamPage from "./pages/TeamPage";
import CapacityBuildingPage from "./pages/CapacityBuildingPage";
import Loader from "./components/Loader"; // Ensure this import is correct

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [loaderType, setLoaderType] = useState("fingerprint"); // Default to Lottie loader

  useEffect(() => {
    setTimeout(() => setIsLoading(false), 3000); // Simulate loading for 3 seconds
  }, []);

  const toggleLoader = () => {
    setLoaderType(loaderType === "lottie" ? "fingerprint" : "lottie");
  };

  return (
    <div className="App w-full">
      {isLoading ? (
        <div>
          <Loader loaderType={loaderType} /> {/* Pass loaderType */}
        </div>
      ) : (
        <>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/initiatives" element={<InitiativesPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/capacity-building" element={<CapacityBuildingPage />} />
            {/* Add more routes as needed */}
          </Routes>
          <Toaster />
          <ToastContainer />
        </>
      )}
    </div>
  );
}

export default App;
